/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2025
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */
import React from 'react';
import { useSelector } from 'react-redux';
import { UserManagementLandingPage } from '@bmsp/bmsp.webcomponent.user.management';
import { consumeAPIs, IAPIPackage } from '../../commonUtils/APIContext';
import './UserManagementNew.scss';
import { IOrganisationState, IUserState } from '../../commonUtils/Redux/Global/globalShared';
import { useFlags } from 'launchdarkly-react-client-sdk';
import i18next from '../../../i18next';
import { isFeatureFlagEnabledForUser } from '../../commonUtils/LDFlagUtils';

export interface IUserManagementNewProps extends IAPIPackage {
  canCreateUser?: boolean;
  canEditUser?: boolean;
  canDeleteUser?: boolean;
}

export const UserManagementNew = (props: IUserManagementNewProps) => {
  const orgSelected = useSelector((state: IOrganisationState) => state.globalShared.gatewaySelectedOrganisation);
  const userProfile = useSelector((state: IUserState) => state.globalShared.userList);
  const featureFlags = useFlags();

  const featureFlagProps = {
    ...featureFlags,
    canCreateUser: props.canCreateUser ?? false,
    canEditUser: props.canEditUser ?? false,
    canDeleteUser: props.canDeleteUser ?? false,
  };

  return (
    <div className='user-management-container'>
      {orgSelected && userProfile && (
        <UserManagementLandingPage
          {...props}
          userProfile={userProfile}
          organisation={orgSelected}
          featureFlags={featureFlagProps}
          i18Lng={i18next}
          isBmsAssistProjectOsSubscriptionEnabled={isFeatureFlagEnabledForUser('bmsAssistProjectOsSubscription', featureFlags, userProfile?.email)}
          isBmsAssistProjectOsSubscriptionEnabledByOrgId={isFeatureFlagEnabledForUser('bmsAssistProjectOsSubscription', featureFlags, orgSelected?.id)}
        />
      )}
    </div>
  );
};

export default consumeAPIs(UserManagementNew);